

<template>
    <div :class="{ 'background-overlay': true, 'hidden': !showPopupContainer, 'visible': showPopupContainer }"
        v-if="showPopup">
        <div class="popup-container">
            <div class="pipedriveWebForms" ref="webFormsContainer"
                data-pd-webforms="https://webforms.pipedrive.com/f/1CvpnFJqCr5hFv5mI8AxFfOgkIUHdrnYljDqjhok23wKE4E2jkKew1T4xbADVJmhR">
            </div>
            <button class="absolute mr-[10px] mt-[10px]" @click="hidePopup">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5}
                    stroke="currentColor" class="w-6 h-6">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
                </svg>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: "WebForms",
    data() {
        return {
            showPopup: !this.$cookies.get('popup_closed'),
            showPopupContainer: false
        };
    },
    mounted() {
        setTimeout(() => {
            if (this.$cookies.get('popup_closed') !== 'true') {
                this.$cookies.set("popup_closed", 'false');
            }
            this.showPopupContainer = true
        }, 60000);
    },
    methods: {
        hidePopup() {
            this.$cookies.set("popup_closed", 'true', { expires: 1 });
            this.showPopup = false
        }
    }
};
</script>

<style scoped>

.popup-container {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1000;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}

.pipedriveWebForms {
    background: white;
    width: 480px;
    padding: 32px;
    border-radius: 20px;
    height: auto;

    @media (max-width: 480px) {
        width: max-content;
    }
}
</style>


